module.exports = __webpack_public_path__ + "static/the-pack-homepage-e3420511d4e60ba654545ffca7c3840a.jpg";